export const loginModal = {
  loginEmail: "请输入您的电子邮件!",
  loginUserName: "请输入您的用户名!",
  loginPassword: "请输入您的密码!",
  loginForgotPassword: "忘记密码?",
  loginPasswordRecoverTitle: "密码恢复",
  loginPasswordRecover: "密码恢复成功",
  loginPasswordRecoverMsg: "检查您的电子邮件以重置您的密码",
  loginNoAccount: "没有账户?",
  loginRegister: "注册",
  loginUserNotFound: "未找到用户",
  loginIncorrectPasswordEmail: "用户或密码无效",
  loginSendBtn: "确定",
  loginSessionTitle: "登录",
  loginEmailPlaceholder: "电子邮件",
  loginEmailLocalPartPlaceholder: "用户名",
  loginEmailDomainOther: "其他",
  loginEmailCustomDomainPlaceholder: "域名.com",
  loginPasswordPlaceholder: "密码",
  loginRecoverEmail: "不记得您注册时使用的电子邮件了吗? 通过联系支持团队来恢复您的帐户。",
  loginSupport: "技术支持",
  loginRememberEmail: "记住我的邮箱",
};
